import React from "react";
import { FieldRendererProps } from "../types";
import { ToggleButtonGroup } from "../../ToggleButton";

export const ToggleFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, getFieldValue, handleInputChange, errors,
}) => (
  <ToggleButtonGroup
    campo={campo}
    getFieldValue={getFieldValue}
    handleInputChange={handleInputChange}
    hasError={!!errors[campo.nome]}
    opcoes={campo.opcoes || []}
    corSelecionado="#0033cc"
    corBorda="#0033cc"
    corTexto="#0033cc"
    onCampoDigitar={(e: any) => {
      campo.onCampoDigitar && campo.onCampoDigitar(e.value);
      handleInputChange(campo.nome, e.value);
    }}
    defaultValue={campo.defaultValueToggle}
  />
);
